import Flip from "gsap/Flip";
import gsap from "gsap";
gsap.registerPlugin(Flip);

export default function popup() {
    const items = gsap.utils.toArray(".popup-image"),
        details = document.querySelector('.popup-zoom'),
        detailImage = document.querySelector('.popup-zoom img');

let activeItem; // keeps track of which item is open (details)


function showDetails(item) {
	if (activeItem) { // someone could click on an element behind the open details panel in which case we should just close it.
		return hideDetails();
	}
	let onLoad = () => {

		// position the details on top of the item (scaled down)
		Flip.fit(details, item, {scale: true, fitChild: detailImage});

		// record the state
		const state = Flip.getState(details);

		// set the final state
		gsap.set(details, {clearProps: true}); // wipe out all inline stuff so it's in the native state (not scaled)
		gsap.set(details, {xPercent: -50, top: "50%", yPercent: -50, visibility: "visible", overflow: "hidden"});

        Flip.from(state, {
            duration: .3,
            fade: true,
            ease: "power2.inOut",
            scale: true,
            // onComplete: () => gsap.set(details, { overflow: "auto" }) // to permit scrolling if necessary
        });

		detailImage.removeEventListener("load", onLoad);
		document.addEventListener('click', hideDetails);
	};

	// Change image and text
	detailImage.addEventListener("load", onLoad);
	detailImage.src = item.querySelector('img').src;

	// stagger-fade the items out from the one that was selected in a staggered way (and kill the tween of the selected item)
	gsap.to(items, {opacity: 0.2}).kill(item);
	activeItem = item;
}

function hideDetails() {
	document.removeEventListener('click', hideDetails);
	gsap.set(details, {overflow: "hidden"});

	// record the current state of details
	const state = Flip.getState(details);

	// scale details down so that its detailImage fits exactly on top of activeItem
	Flip.fit(details, activeItem, {scale: true, fitChild: detailImage});

	const tl = gsap.timeline();
	tl.set(details, { overflow: "hidden"})
        .to(items, { opacity: 1 })

	// animate from the original state to the current one.
	Flip.from(state, {
		scale: true,
        duration: .3,
        fade: true,
        ease: "power2.inOut",
        autoAlpha: 0,
        onInterrupt: () => tl.kill(),
        onComplete: () => {
            gsap.set(details, { clearProps: true })
            gsap.set(detailImage, { clearProps: true })
            detailImage.src = null
        }
	})
	  .set(details, {visibility: "hidden"});

	activeItem = null;
}

// Add click listeners
gsap.utils.toArray('.popup-image').forEach(item => item.addEventListener('click', () => showDetails(item)));

}
